import { render, staticRenderFns } from "./ShiftWorkSummary.vue?vue&type=template&id=bf74273e"
import script from "./ShiftWorkSummary.vue?vue&type=script&lang=js"
export * from "./ShiftWorkSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports